/**
 * Created by mac on 3/2/21
 */

const FullscreenControlButton = {
    name: "FullscreenControlButton",
    buttonType: "control_button",
    icon: bundles.controlbuttons.frames.fullscreen_icon_png,

    onClicked: function () {
        connector.platform.toggleFullScreen();
    },

    isAvailableOnScene: function () {
        if (cleverapps.config.wysiwygMode) {
            return false;
        }

        if (cleverapps.config.type === "battlefield" && Game.currentGame && Game.currentGame.mode === Epicart.MODE_BATTLE) {
            return false;
        }

        if (cleverapps.environment.hasScene([cleverapps.Environment.SCENE_CHAT, cleverapps.Environment.SCENE_MINE, cleverapps.Environment.SCENE_SLOT_MACHINE])) {
            return false;
        }

        if (cc.sys.isNative || cc.sys.isMobile || cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            return false;
        }

        return connector.platform.isFullscreenAvailable();
    }
};
